import { getToken, _fetch } from "./apiHelper";
import { protectedResources } from "../config/authConfig";

export const getDashboardData = async (projectCode : string, startDate : string, endDate : string) => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  // Construct the query string
  const queryParams = new URLSearchParams({
    projectCode,
    startDate,
    endDate,
  }).toString();

  const url = `${protectedResources.api.dashboard}?${queryParams}`;

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(url, options);
};
